import { mapGetters } from "vuex";

// Restricts a view to agency staff — gendev / admin / properties (the comerciales).
// Owners/tenants are redirected home. Keyed off currentUser (which can resolve after
// mount), so it works on a hard refresh too. Backend resolvers enforce the same set.
const STAFF_ROLES = ["gendev", "admin", "properties"];

export default {
  computed: { ...mapGetters(["currentUser"]) },
  watch: {
    currentUser: {
      immediate: true,
      handler(user) {
        if (!user || !Array.isArray(user.displayRoles)) return;
        if (!STAFF_ROLES.some(r => user.displayRoles.includes(r))) {
          this.$router.replace("/");
        }
      }
    }
  }
};
